import { OverlayState } from '../store/overlay';
import { useAppSelector } from './store';

export const useOverlayState = () => {
  return useAppSelector<OverlayState>((state) => state.overlay).active;
};
